module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Readers love")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t1"
  }, [_c('img', {
    attrs: {
      "alt": "img1.jpg",
      "src": "Images/img1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("A Night Owl Reviews Top Pick!")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“There is enough in Dreamlands to satisfy those with a taste for gentle romance, for action sequences, for character driven stories and also (as a brief warning) mindless violence, especially towards the end of the book.”")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("—Reviews by Jessewave")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“This debut novel from a new author is a stunning piece of work. Intricately plotted with fascinating world building and creative characters, this story captures interest immediately and carries it through to the end.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Rainbow Reviews")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“"), _c('span', {
    staticClass: "t4"
  }, [_vm._v("A great mix of fantasy, historical Japan, and science fiction.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("—Hearts on Fire Reviews")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47993f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/002.vue
// module id = 57
// module chunks = 0